const content = {
    'youtube_watch_history': {
        en: {
            data_type_description: 'YouTube Watch History',
            summary_html: `
                <p>Retro jobs are simple, quick and a bit of fun too. Watch the video and read the steps below, and then
                    you're ready to hit record and scroll through your YouTube history.</p>
                <div class="text-with-icon">
                    <div class="icon">⚠️</div>
                    <div class="text">
                    We'll only pay MSR rewards for videos that fully match the steps below.
                    </div>
                </div>`,
            summary_no_video_html: `
                <p>Retro jobs are simple, quick and a bit of fun too. Read the steps below, and then you're ready to hit
                    record and scroll through your YouTube history.</p>
                <div class="text-with-icon">
                    <div class="icon">⚠️</div>
                    <div class="text">
                    We'll only pay MSR rewards for videos that fully match the steps below.
                    </div>
                </div>`,
            video_thumbnail: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/youtube-watch-history/video-thumbnail.jpg',
            video_url: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/youtube-watch-history/Youtube_Retro_iOS.mp4',
            video_poster: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/youtube-watch-history/YouTube_Retro_iOS_placeholder.jpg',
            video_show_web_client: false,
            steps: [
                {
                    step_type: 'numbered_step',
                    number: '1',
                    description_html: '<p>Open the app and log in before starting to screen record.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '2',
                    description_html: '<p>Hit the <b>Library</b> icon on the bottom-right side of the navigation.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '3',
                    description_html: '<p>Go to <b>History</b> and scroll down through the <b>last 3 months</b> of history before you stop recording.</p>'
                }
            ],
        }
    },
    google_activity_history: {
        en: {
            data_type_description: 'Google My Activity',
            summary_no_video_html: `
          <h2>Before you start</h2> 
          <p>It's important you complete each step, or we won't be able to process your payment! Our
            instructions are easy to follow.</p>`,
            steps: [
                {
                    step_type: 'numbered_step',
                    number: '1',
                    description_html: `
              <p>To open Google Activity,
                <a href="https://myactivity.google.com/u/2/item?pageId=none&min=1661151600000000&max=1669190399999999&product=11%2C19%2C25" target="_blank">
                  tap here</a>
                <img style="height:10px;margin-right:2px" src="https://d3s00xghdjywqy.cloudfront.net/c2/retro/google-activity/open-icon@3x.png" />.
              </p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '2',
                    description_html: `
              <p class="paragraph-with-hint">Make sure you are logged in to your <b>main Google account</b> by checking the icon
                <img style="height:20px;margin-right:2px;margin-left:2px;"
                  src="https://d3s00xghdjywqy.cloudfront.net/c2/retro/google-activity/account-icon@3x.png" />
                in the top-right corner.</p>
              <p><i>This icon could be a letter or a photo.</i></p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '3',
                    description_html: `
              <p class="paragraph-with-hint">Start screen recording
              <img style="height:20px;vertical-align:-3px;margin-right: 2px;margin-left: 2px;"
                src="https://d3s00xghdjywqy.cloudfront.net/c2/retro/google-activity/screen-record-icon@3x.png" />
              and scroll as fast as you can to the bottom of the list.</p>
              <p><i>This will take 1–2 minutes</i></p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '4',
                    description_html: `<p>When you see the words <b style="color:#228bff">Load more</b> at the bottom of the page. Wait
              for it to load before continuing to scroll.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '5',
                    description_html: `<p>Once you’ve reached the bottom of the page and see the words:</p>
              <p style="color:#666666;"><i>"Looks like you have reached the end"</i></p>
              <p>... stop recording and upload.</p>`
                }
            ],
            after_steps_html: `<h2 class="hint-title" style="margin-top:1.5rem;">Helpful hint</h2>
          <p>It is recommended that you upload your video when connected to wifi.</p>`,

        }
    },
    google_takeout_data_portability: {
        en: {
            summary_no_video_html: `
            <p>Follow the steps below to grant MSR access to download your Google activity.</p>
            <p>MSR has security measures in place to keep your data private and secure.</p>`,
            steps: [
                {
                    step_type: 'numbered_step',
                    number: '1',
                    description_html: `
                <p>Tap <b>start</b> to begin.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '2',
                    description_html: `
                <p>Login into your Google Account.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '3',
                    description_html: `
                <p>Grant MSR access to your Google account. Click on <b>Select all</b>.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '4',
                    description_html: `
                <p>Scroll and select <b>30 days</b>. MSR has security measures in place to keep your data private and secure.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '5',
                    description_html: `
                <p>Click on <b>Continue</b>.</p>`
                }
            ],
        },
    },
    digital_wellbeing_app_usage_1_day: {
        en: {
            summary_html: `<p>This screen recording video task has several steps. Please follow the instructions carefully..</p>`,
            steps: [
                {
                    step_type: 'numbered_step',
                    number: '1',
                    description_html: `<p>Do not start recording yet - open your phone's Settings and search <b>Digital Wellbeing</b>.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '2',
                    description_html: '<p>Tap on <b>Digital Wellbeing and parental controls</b>.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '3',
                    description_html: '<p>Tap on <b>TODAY</b>.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '4',
                    description_html: `<p>Under <b>Activity details</b>, select the day before by tapping on the bar graph, or the < back arrow next to the date.</p>`
                },
                {
                    step_type: 'centered_image',
                    image_width: '200px',
                    image_url: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/itv/activity_details.png'
                },
                {
                    step_type: 'numbered_step',
                    number: '5',
                    description_html: `<p>Head back to the MSR app and start the screen recording by tapping on the button below.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '6',
                    description_html: `<p>Scroll down through the page and find the following apps (if you have used them): <b>Netflix,
                        YouTube, TikTok, Instagram, Amazon Prime Video, Hulu, Apple TV+, Disney+.</b></p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '7',
                    description_html: `<p>Each time you find the following apps, tap on them to get more information about your app
                        usage and select <b>Hourly</b>. For example:</b></p>`
                },
                {
                    step_type: 'centered_image',
                    image_width: '200px',
                    image_url: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/itv/android_usage_app_data.gif'
                },
                {
                    step_type: 'numbered_step',
                    number: '8',
                    description_html: `<p>Continue to scroll down until you see app with <b>0 minutes</b> recording.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '9',
                    description_html: `<p>One final step. We need to get usage information for the "Gaming" category, if available. Go back
                        to the main Dashboard in the Digital Wellbeing app. Tap on the chart at the top of the screen. That will take you to
                        a detail screen. If there is a listing of app categories (e.g. "Social", "Productivity", "Gaming"), tap on the "Gaming"
                        category (it may be called "Game" or "Games" instead). Scroll to the bottom of that page.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '10',
                    description_html: `<p>Return to MSR, stop recording, and share your video.</p>`
                },
            ],
            video_show_web_client: true,
        },
    },
    digital_wellbeing_app_usage_7_day: {
        en: {
            summary_html: `<p>This screen recording video task has several steps. Please follow the instructions carefully.</p>`,
            steps: [
                {
                    step_type: 'numbered_step',
                    number: '1',
                    description_html: `<p>Do not start recording yet - open your phone's Settings and search <b>Digital Wellbeing</b>.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '2',
                    description_html: '<p>Tap on <b>Digital Wellbeing and parental controls</b>.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '3',
                    description_html: '<p>Tap on <b>TODAY</b>.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '4',
                    description_html: `<p>Under <b>Activity details</b>, select the day before by tapping on the bar graph, or the < back arrow next to the date.</p>`
                },
                {
                    step_type: 'centered_image',
                    image_width: '200px',
                    image_url: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/itv/activity_details.png'
                },
                {
                    step_type: 'numbered_step',
                    number: '5',
                    description_html: `<p>Head back to the MSR app and start the screen recording by tapping on the button below.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '6',
                    description_html: `<p>Scroll down through the page and find the following apps (if you have used them): <b>Netflix,
                        YouTube, TikTok, Instagram, Amazon Prime Video, Hulu, Apple TV+, Disney+.</b></p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '7',
                    description_html: `<p>Each time you find the following apps, tap on them to get more information about your app
                        usage and select <b>Hourly</b>. For example:</b></p>`
                },
                {
                    step_type: 'centered_image',
                    image_width: '200px',
                    image_url: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/itv/android_usage_app_data.gif'
                },
                {
                    step_type: 'numbered_step',
                    number: '8',
                    description_html: `<p>Continue to scroll down until you see an app with <b>0 minutes</b>.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '9',
                    description_html: `<p>Now we need to get usage information for the "Gaming" category, if available. Go back
                        to the main Dashboard in the Digital Wellbeing app. Tap on the chart at the top of the screen. That will take you to
                        a detail screen. If there is a listing of app categories (e.g. "Social", "Productivity", "Gaming"), tap on the "Gaming"
                        category (it may be called "Game" or "Games" instead). Scroll to the bottom of that page.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '10',
                    description_html: `<p>Tap on the back arrow < again and repeat this for another 6 days, so that we have a total of
                        a week of data. Again, please open the following apps if you use them and select Hourly for each: <b>Netflix, YouTube,
                        TikTok, Instagram, Amazon Prime Video, Hulu, Apple TV+, Disney+</b>.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '11',
                    description_html: `<p>Return to MSR, stop recording, and share your video.</p>`
                },
            ],
            video_show_web_client: true,
        },
    },
    stayfree_app_usage_1_day: {
        en: {
            summary_html: `<p>This screen recording video task has several steps, the first of which is installing a new app. Please follow the instructions carefully.</p>`,
            steps: [
                {
                    step_type: 'numbered_step',
                    number: '1',
                    description_html: `<p>Do not start recording yet. The first thing you need to do is install an app called
                        <a target="_blank" href="https://play.google.com/store/apps/details?id=com.burockgames.timeclocker&pcampaignid=web_share">StayFree from
                        the Play Store</a>. This is a free app that provides some reporting on your mobile phone usage. Click on
                        <a target="_blank" href="https://play.google.com/store/apps/details?id=com.burockgames.timeclocker&pcampaignid=web_share">this link</a>
                        and follow instructions to install.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '2',
                    description_html: `<p>Now that the app is installed, open it and tap through the setup. You'll have to give the app permission
                        to access your app usage. When you're setup, you should be able to see some of your app usage data. Now you're ready
                        to record.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '3',
                    description_html: '<p>Start the screen recorder.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '4',
                    description_html: `<p>Go back to the <b>StayFree</b> app and tap on the left arrow at the bottom of the screen (or
                        use the date picker) to select "Yesterday".</p>`
                },
                {
                    step_type: 'centered_image',
                    image_width: '300px',
                    image_url: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/stayfree_app_usage/yesterday.png'
                },
                {
                    step_type: 'numbered_step',
                    number: '5',
                    description_html: `<p>Now scroll through the list of apps until you get to the bottom. (These are all the apps you used yesterday.)</p>`
                },
                {
                    step_type: 'centered_image',
                    image_width: '200px',
                    image_url: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/stayfree_app_usage/app-list.png'
                },
                {
                    step_type: 'numbered_step',
                    number: '6',
                    description_html: `<p>If you find any of the following apps in the list (you will see the ones that you used), tap on them
                        to get more information. Scroll down to the bottom of the screen so that the usage chart is visible. Do this for each app
                        and then go back to the main list. Here are the apps: <b>Netflix, YouTube, TikTok, Instagram, Amazon Prime Video, Hulu, Apple TV+, Disney+.</b></p>`
                },
                {
                    step_type: 'centered_image',
                    image_width: '200px',
                    image_url: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/stayfree_app_usage/app-chart.png'
                },
                {
                    step_type: 'emoji_step',
                    emoji: '💡',
                    description_html: `<p>If you switch away from the StayFree app and then back, ensure that the date is set to "Yesterday". The app will
                        occasionally automatically switches back to "Today".</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '7',
                    description_html: `<p>Finally, go back to the top of the screen and open the "Category" filter, on the left. If you see a Gaming
                        category, tap that to see information on your usage of that category. Scroll to the bottom of that screen.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '8',
                    description_html: `<p>And you're done! Return to MSR, stop recording, and share your video.</p>`
                },
            ],
            video_show_web_client: true,
        },
    },
    usage_analyzer_app_usage_1_day: {
        en: {
            summary_html: `<p>This screen recording video task has several steps, the first of which is installing a new app. Please follow the instructions carefully.</p>`,
            steps: [
                {
                    step_type: 'numbered_step',
                    number: '1',
                    description_html: `<p>Do not start recording yet. The first thing you need to do is install an app called
                        <a target="_blank" href="https://play.google.com/store/apps/details?id=info.kfsoft.usageanalyzer">Usage Analyzer from
                        the Play Store</a>. This is a free app that provides some reporting on your mobile phone usage. Click on
                        <a target="_blank" href="https://play.google.com/store/apps/details?id=info.kfsoft.usageanalyzer">this link</a>
                        and follow instructions to install.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '2',
                    description_html: `<p>Now that the app is installed, open it and tap through the setup. You'll have to give the app permission
                        to access your app usage. It'll open the permissions page for you and you simply toggle to "on" for the App Usage app.
                        When you're setup, you should be able to see some of your app usage data. Now you're ready to record.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '3',
                    description_html: '<p>Go back to the MSR app and Start the screen recorder.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '4',
                    description_html: `<p>Go to the <b>Usage Analyzer</b> app and tap on the history icon at the top of the screen.
                        This is the one that looks like a clock with an arrow around it.</p>`
                },
                {
                    step_type: 'centered_image',
                    image_width: '300px',
                    image_url: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/usage-analyzer-app-usage/usage-analyzer-history-button.png'
                },
                {
                    step_type: 'numbered_step',
                    number: '5',
                    description_html: `<p>You should see your recent app usage listed. Now scroll through that list until you get to the end (it should be at least one week).</p>`
                },
                {
                    step_type: 'centered_image',
                    image_width: '200px',
                    image_url: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/usage-analyzer-app-usage/usage-analyzer-screen.png'
                },
                {
                    step_type: 'numbered_step',
                    number: '8',
                    description_html: `<p>And you're done! Return to MSR, stop recording, and share your video.</p>`
                },
            ],
            video_show_web_client: true,
        },
    },
    chrome_web_browsing_history: {
        ios: {
            en: {
                summary_html: '',
                summary_no_video_html: `
                  <p>Retro jobs are simple and quick. Read the steps below, and then you're ready to hit record and scroll
                      through your web browsing history in Chrome.</p>
                  <div class="text-with-icon">
                    <div class="icon">⚠️</div>
                    <div class="text">
                      We’ll only pay MSR rewards for videos that fully match the steps below.
                    </div>
                  </div>`,
                steps: [
                    {
                        step_type: 'numbered_step',
                        number: '1',
                        description_html: '<p>Open the <b>Chrome</b> app on your phone.</p>'
                    },
                    {
                        step_type: 'numbered_step',
                        number: '2',
                        description_html: '<p>In the app, tap on the <b>menu icon</b> (in the bottom-right) and select <b>History</b>.</p>'
                    },
                    {
                        step_type: 'numbered_step',
                        number: '3',
                        description_html: '<p>Start the screen recording.</p>'
                    },
                    {
                        step_type: 'numbered_step',
                        number: '4',
                        description_html: `<p>Scroll quickly through your history — stop the recording once you have scrolled
                      back through three months of history <i>or</i> you hit the end.</p>`
                    }
                ],
            },
        },
        android: {
            en: {
                summary_html: '',
                summary_no_video_html: `
        <p>Retro jobs are simple and quick. Read the steps below, and then you're ready to hit record and scroll
            through your web browsing history in Chrome.</p>
        <div class="text-with-icon">
          <div class="icon">⚠️</div>
          <div class="text">
            We’ll only pay MSR rewards for videos that fully match the steps below.
          </div>
        </div>`,
                steps: [
                    {
                        step_type: 'numbered_step',
                        number: '1',
                        description_html: '<p>Tap to start recording, and then open the <b>Chrome</b> app on your phone.</p>'
                    },
                    {
                        step_type: 'numbered_step',
                        number: '2',
                        description_html: `
            <p>In the app, tap on the <b>menu icon</b> (three dots in the top-right, some sometimes a red arrow
                if Chrome needs updating) and select <b>History</b>.</p>`
                    },
                    {
                        step_type: 'numbered_step',
                        number: '3',
                        description_html: '<p>Scroll quickly back through three months of history <i>or</i> you hit the end.</p>'
                    },
                    {
                        step_type: 'numbered_step',
                        number: '4',
                        description_html: `<p>Switch back to MSR and stop recording.</p>`
                    }
                ],
            }
        }
    },
    android_screen_time_stats: {
        en: {
            summary_no_video_html: `
            <h2>Before you start</h2> 
            <p>This data includes a maximum of 10-days of previous app usage. Any future sharing will be done with a new Retro task sent to your feed, which will include a new reward.</p>`,
            steps: [
                {
                    step_type: 'numbered_step',
                    number: '1',
                    description_html: `
                <p>Tap <b>start</b> to begin.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '2',
                    description_html: `
                <p>You will need to ‘permit usage access’ to the MSR app in your ‘usage access’ settings. If you have not done this yet, tapping on <b>start</b> will directly open the ‘usage access’ settings.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '3',
                    description_html: `
                <p>Return to the MSR app after you have changed the settings.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '4',
                    description_html: `
                <p>The MSR app will fetch your app usage data.</p>`
                }
            ],
        },
    },

}

export const googleDataTypes = {
    'youtube_watch_history': {
        data_type: 'youtube_watch_history',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/youtube-watch-history/logo.png',
        capture_type: 'video',
        android: {
            use_in_app_screen_recorder: true,
            ...content.youtube_watch_history,
        },
        ios: {
            use_in_app_screen_recorder: false,
            ...content.youtube_watch_history,
        },
    },
    google_activity_history: {
        data_type: 'google_activity_history',
        capture_type: 'video',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/google-activity/logo.png',
        ios: {
            use_in_app_screen_recorder: false,
            ...content.google_activity_history,
        },
        android: {
            use_in_app_screen_recorder: true,
            ...content.google_activity_history,
        },
    },
    android_screen_time_stats: {
        data_type: 'android_screen_time_stats',
        data_type_description: 'Android Usage Stats',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/android.png',
        capture_type: 'android_screen_time_stats',
        generic: {
            ...content.android_screen_time_stats
        }
    },
    digital_wellbeing_app_usage_1_day: {
        data_type: 'digital_wellbeing_app_usage_1_day',
        data_type_description: 'Digital Wellbeing App Usage 1 Day',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/android.png',
        capture_type: 'video',
        generic: {
            use_in_app_screen_recorder: true,
            ...content.digital_wellbeing_app_usage_1_day
        }
    },
    digital_wellbeing_app_usage_7_day: {
        data_type: 'digital_wellbeing_app_usage_7_day',
        data_type_description: 'Digital Wellbeing App Usage 7 Day',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/android.png',
        capture_type: 'video',
        generic: {
            use_in_app_screen_recorder: true,
            ...content.digital_wellbeing_app_usage_7_day
        }
    },
    stayfree_app_usage_1_day: {
        data_type: 'stayfree_app_usage_1_day',
        data_type_description: 'StayFree App Usage 1 Day',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/android.png',
        capture_type: 'video',
        generic: {
            use_in_app_screen_recorder: true,
            ...content.stayfree_app_usage_1_day
        }
    },
    usage_analyzer_app_usage_1_day: {
        data_type: 'usage_analyzer_app_usage_1_day',
        data_type_description: 'App Usage App Usage 1 Day',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/android.png',
        capture_type: 'video',
        generic: {
            use_in_app_screen_recorder: true,
            ...content.usage_analyzer_app_usage_1_day
        }
    },
    'chrome_web_browsing_history': {
        data_type: 'chrome_web_browsing_history',
        data_type_description: 'Chrome Web Browsing History',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/chrome-web-browsing-history/logo.png',
        capture_type: 'video',
        ios: {
            use_in_app_screen_recorder: false,
            ...content.chrome_web_browsing_history.ios,
        },
        android: {
            use_in_app_screen_recorder: true,
            ...content.chrome_web_browsing_history.android,
        }
    },
    google_takeout_data_portability: {
        data_type: 'google_takeout_data_portability',
        data_type_description: 'Google Takeout',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/google-activity/logo.png',
        capture_type: 'google_takeout_data_portability',
        generic: {
            ...content.google_takeout_data_portability
        }
    },
}